// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import { wizardComponents } from './componentsMap';

export default {
  name: "realWorldDataTable",
  data() {
    return {
      currentWizard: '',
      // 個車情報取得各機能定義
      realWorldDataItems: [
        {
          function: 'isa',
          systemId: 'realWorldDataISA',
          buttonLabel: this.$t('message.label_function_menu_vehicle_information_isa')
        },
        {
          function: 'vsoc',
          systemId: 'realWorldDataVSOC',
          buttonLabel: this.$t('message.label_function_menu_vehicle_information_vsoc')
        },
      ],
    };
  },

  components: {
    ...wizardComponents
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
      }
    },
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('observation', ['usageCountUp']),

    // アイコンのクリック処理
    clickItem(item) {
      // システムIDの取得
      const systemId = item.systemId;
      this.currentWizard = systemId;
      // 個車情報取得利用回数カウントアップ
      this.usageCountUp({ type: config.USAGE_COUNT_TYPE_REAL_WORLD_DATA });
    },

    /** ウィザードを閉じた後の処理 */
    closeWizard() {
      this.currentWizard = '';
    },
  },

  computed: {
    ...mapState({
      realWorldDataMenus: state => state.vehicle.realWorldDataMenus,
      language: state => state.systems.language,
    }),
  },

  mounted() {
    this.$emit('setVehicleTabsAvailable', true);
  },
};
